import React from 'react'
import { BottomSheet } from "react-spring-bottom-sheet";
import ILWarning from "../../assets/images/il-warning.png";


// if setting up the CSS is tricky, you can add this to your page somewhere:
// <link rel="stylesheet" href="https://unpkg.com/react-spring-bottom-sheet/dist/style.css" crossorigin="anonymous">
import "react-spring-bottom-sheet/dist/style.css";
type Props = {}

const ErrorSheet = ({sheetDetail, setSheetDetail}) => {



  function onDismiss() {
    setSheetDetail({
      ...sheetDetail,
      open: false,
    });
  }
  return (
<BottomSheet
        open={sheetDetail.open}
        onDismiss={onDismiss}
        snapPoints={({ minHeight }) => minHeight}
      >
        <div>
          <div className="space-y-4 px-5 pb-8 pt-4">
            <img src={ILWarning} className="mx-auto h-20" alt="Warning" />
            <div className="text-center text-base space-y-1">
              <strong className='text-lg text-gray-700'>{sheetDetail.title}</strong>
              <p className="text-gray-500">
              {sheetDetail.detail}
              </p>
            </div>
            <button onClick={onDismiss} className="w-full text-gray-400">
              Close
            </button>
          </div>
        </div>
      </BottomSheet>
  )
}

export default ErrorSheet